import { render, staticRenderFns } from "./QuizQuestionEditor.vue?vue&type=template&id=4aab4128&"
import script from "./QuizQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./QuizQuestionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports